import { writable } from "svelte/store";
import { isPrimaryCampaign } from "../constants/countries";

export const availableLanguages = ["en", "es", "fr"];
export type Language = typeof availableLanguages[number];

export const initStore = () => {
  const defaultState: Language = isPrimaryCampaign ? "en" : "es";

  if (!isPrimaryCampaign) {
    localStorage.setItem("language", "es")
  }

  const initialState = localStorage.getItem("language") as Language;
  const store = writable<Language>(initialState || defaultState);

  store.subscribe(($store) => {
    localStorage.setItem("language", $store);
  });

  return store;
};

export const languageStore = initStore();

export const set = (language: Language) => languageStore.set(language);
